import './ArrowToggleInput.less';
import React from 'react';
import Icon from "../icon/Icon";

export default class ArrowToggleInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: !!props.defaultValue
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== undefined) {
            state.value = !!props.value;

            return state;
        }

        if (props.imperativeValue !== state.prevImperativeValue) {
            state.prevImperativeValue = props.imperativeValue;

            state.value = !!props.imperativeValue;

            return state;
        }

        return null;
    }

    setValue = (value) => {
        const {onChange} = this.props;

        this.setState({
            value: value
        }, onChange ? () => setTimeout(() => onChange(value), 0) : undefined);
    };

    render() {
        const {label, truthyLabel = label, disabled} = this.props;
        const {value} = this.state;

        return <div
            className={'arrow-toggle-input' + (value ? ' checked' : '') + (disabled ? ' disabled' : '')}
        >
            <div
                className="inner"
                onClick={() => disabled || this.setValue(!value)}
            >
                <div className="label">
                    {value ? truthyLabel : label}
                </div>

                <div className="ic-holder">
                    <Icon name={value ? 'angle-up' : 'angle-down'}/>
                </div>
            </div>
        </div>
    }
}